import { render, staticRenderFns } from "./AddPatent.vue?vue&type=template&id=4d816ab5"
import script from "./AddPatent.vue?vue&type=script&lang=js"
export * from "./AddPatent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports